/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { api } from '.';

import { ApiRoutes } from '@/constant/api';

import {
	AllObjectsResponseType,
	ObjectRequestType,
	ObjectsResponseParamsType,
	ObjectsResponseType,
} from '@/types/object';
import { BookingObject } from '@/types/person';

const objectsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getAllObjects: builder.query<AllObjectsResponseType, boolean | void>({
			query: (is_admin = false) => ({
				url: ApiRoutes.Objects,
				params: {
					is_admin,
				},
			}),
			providesTags: ['AllObjects'],
		}),
		getAvailableObjects: builder.query<ObjectsResponseType, ObjectsResponseParamsType>({
			query: ({ parentId, from, till }) => ({
				url: `${ApiRoutes.Objects}/${parentId}/for_booking`,
				params: { from, till },
			}),
			providesTags: ['AvailableObjects'],
		}),
		getRootObjects: builder.query<AllObjectsResponseType, boolean | void>({
			query: (is_admin = false) => ({
				url: ApiRoutes.BookingRootObjects,
				params: {
					is_admin,
				},
			}),
			providesTags: ['RootObjects'],
		}),
		getObject: builder.query<BookingObject, string | undefined>({
			query: (id) => ({
				url: `${ApiRoutes.Objects}/${id}`,
			}),
		}),
		createObject: builder.mutation<null, ObjectRequestType>({
			query: (body) => ({
				url: ApiRoutes.Objects,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['AvailableObjects', 'AllObjects', 'RootObjects'],
		}),
		updateObject: builder.mutation<null, [number, ObjectRequestType]>({
			query: ([id, body]) => ({
				url: `${ApiRoutes.Objects}/${id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['AvailableObjects', 'AllObjects', 'RootObjects'],
		}),
		uploadImage: builder.mutation<null, { id: string | number; body: File }>({
			query: ({ id, body }) => ({
				url: `${ApiRoutes.Objects}/${id}/image`,
				method: 'POST',
				params: { display_name: 'img.svg' },
				headers: { 'Content-Type': 'image/svg+xml' },
				body,
			}),
			invalidatesTags: ['AvailableObjects', 'AllObjects', 'RootObjects'],
		}),
		deleteObject: builder.mutation<null, number>({
			query: (id) => ({
				url: `${ApiRoutes.Objects}/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['AvailableObjects', 'AllObjects', 'RootObjects'],
		}),
	}),
});

export const {
	useGetAllObjectsQuery,
	useGetRootObjectsQuery,
	useGetAvailableObjectsQuery,
	useLazyGetAvailableObjectsQuery,
	useGetObjectQuery,
	useDeleteObjectMutation,
	useCreateObjectMutation,
	useUpdateObjectMutation,
	useUploadImageMutation,
} = objectsApi;
